import { BaseRUMManager } from '@nab/nab-x-sdk-core';
import { RUMEventData } from '.';

/**
 * [[include:packages/consumer/sdk-browser/src/RUMMgr/README.md]]
 */
export class RUMMgr extends BaseRUMManager<RUMEventData> {}
